// extracted by mini-css-extract-plugin
module.exports = {"comp":"GraphicItems_comp__2GKOE"};